import React from 'react';
import PropTypes from 'prop-types';
import { SFConnection, SFEntityID } from 'utils/types';
import css from './ConnectionView.scss';
import ConnectionProfile from './ConnectionProfile';
import ConnectionPlaceholder from './ConnectionPlaceholder';
import ScrollToTopOnMount from 'common/ScrollToTopOnMount';
import { isEmpty } from 'lodash';
import ProfileNotFound from '../ProfileNotFound';

export default class ConnectionView extends React.Component {

  get content() {
    if ( !this.props.hasFetched ) return <ConnectionPlaceholder />;
    if ( isEmpty(this.props.connection) ) return <ProfileNotFound />;
    return (
      <ConnectionProfile
        {...this.props.connection}
        serviceId={this.props.serviceId}
        isStudent={this.props.isStudent}
        isStaff={this.props.isStaff}
      />
    );
  }

  render() {
    return (
      <div className={css['container']}>
        <ScrollToTopOnMount />
        {this.props.renderNotification()}
        {this.content}
      </div>
    );
  }
}

ConnectionView.propTypes = {
  connection: PropTypes.shape(SFConnection),

  /**
   * An optional university service ID, set if a student is viewing a staff
   * member (connection) who's a member of a university service.
   */
  serviceId: SFEntityID,

  hasFetched: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  renderNotification: PropTypes.func.isRequired
};
